import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import Container from "../../components/container/Container";
import Styles from "./NotFound.module.scss";

const NotFound = ({ location }) => {
  return (
    <Layout>
      <Container growHeight={true}>
        <div className={Styles.header}>
          <h1 className={Styles.title}>Nicht gefunden</h1>
          <p className={Styles.intro}>
            Die Seite &laquo;{location.pathname}&raquo; konnte leider nicht
            gefunden werden.
          </p>
          <p>
            <Link className={Styles.link} to="/">
              Zurück zur Startseite
            </Link>
          </p>
        </div>
      </Container>
    </Layout>
  );
};

export default NotFound;
